/**
 * store/modules/app.js
 * @author PeakXin <xinyflove@gmail.com>
 */
const state = {
  isWhiteListed: false
}

const mutations = {
  SET_IS_WHITE_LISTED(state, flag) {
    state.isWhiteListed = flag
  }
}

const getters = {
  isWhiteListed: (state) => state.isWhiteListed
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
